import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import {BsModalService, BsModalRef} from 'ngx-bootstrap';
import { Subject } from 'rxjs';
import { ComponentName, ModalSize } from 'src/app/Enums/usersFilterEnums';
import { ConfirmationModalComponent } from 'src/app/shared/components/confirmation-modal/confirmation-modal.component';
import { OfficesService } from 'src/app/shared/services/offices.service';
import { AddOfficeComponent } from '../add-office/add-office.component';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-offices-header',
  templateUrl: './offices-header.component.html',
  styleUrls: ['./offices-header.component.less']
})
export class OfficesHeaderComponent implements OnInit {
  modalRef: BsModalRef;
  private unsubscribe$ =new Subject<void>();
  @ViewChild('userame') officename: ElementRef;  
  @Output() searchByName = new EventEmitter();
  @Output() resetFilters = new EventEmitter();
  @Input() tableSettings;
  
  constructor(private modalService: BsModalService, private officesService: OfficesService) { }

  ngOnInit() {
    this.officesService.resetHeaders
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe(() => {
      this.officename.nativeElement.value = '';
      this.officesService.refreshPage.next();
    })
  }

  addOffice() {
    this.modalRef = this.modalService.show(AddOfficeComponent);
    this.modalRef.setClass(ModalSize.Large);
  }

  SearchByUser(username) {
    this.searchByName.emit(username);
  }

  ResetFilters() {
    this.modalRef = this.modalService.show(ConfirmationModalComponent);
    this.modalRef.setClass(ModalSize.Small);
    this.modalRef.content.title = 'Reset Filter';
    this.modalRef.content.description = 'Do you want to reset all filters';
    this.modalRef.content.buttonsTitle = {
      dismiss: 'Cancel',
      confirm: 'Reset',
      component: ComponentName.Offices
    }
  }

  hideDropdowns() {
    this.tableSettings.forEach(item => {
      item.displaysort = false;
    })
    // _.each(this.tableSettings, function (item) {
    //   item.displaysort = false;
    // })
  }
  ngOnDestroy(){
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
